import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NewsCard = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <Box
        width={props.width}
        style={{
          borderRadius: "12px",
          padding: "16px",
          boxSizing: "border-box",
          height: "auto",
          minHeight: "240px",
          marginRight: "36px",
          border: "1.6px solid rgba(0,0,0,0.08)",
        }}
      >
        <Grid container>
          {props.image ? (
            <Grid item xs={12}>
              <img
                src={process.env.PUBLIC_URL + "Images/News/" + props.image}
                alt="News"
                width="100%"
              />
            </Grid>
          ) : null}
          <Grid xs={12} item>
            <Typography fontWeight={600} fontSize="20px" marginTop="8px">
              {props.title}
            </Typography>
          </Grid>
          <Grid xs={12} item>
            <Typography
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 4,
              }}
            >
              {props.description}
            </Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography>{props.date}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Button
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
              onClick={() => navigate("/news")}
            >
              <Typography>Read More...</Typography>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default NewsCard;
